import { render, staticRenderFns } from "./top-header.vue?vue&type=template&id=72d3e507&scoped=true&"
import script from "./top-header.vue?vue&type=script&lang=js&"
export * from "./top-header.vue?vue&type=script&lang=js&"
import style0 from "./top-header.vue?vue&type=style&index=0&id=72d3e507&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d3e507",
  null
  
)

export default component.exports